import { render } from "./AnimatedBackground.vue?vue&type=template&id=9bab3b3c&scoped=true"
const script = {}

import "./AnimatedBackground.vue?vue&type=style&index=0&id=9bab3b3c&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_db7f3463623555724ece677ccfae2485/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bab3b3c"]])

export default __exports__